<script>
	import { handleCsvImport } from "src/utils/misc";
	import { onDestroy, onMount } from "svelte";
	import { field, form } from "svelte-forms";
	import { required } from "svelte-forms/validators";
	import { Button, Col, Row } from "@sveltestrap/sveltestrap";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";
	import ErrorMessageHandler from "../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import Loader from "../../../../components/Loader/Loader.svelte";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import client from "../../../../services/client";
	import {
		errorMessage,
		initPage,
		loading,
		loadingStatus,
		totalPages,
	} from "../../../../store/store";
	import VehicleAssetOwnerTable from "./VehicleAssetOwnerTable.svelte";

	onMount(async () => {
		try {
			loading.set(true);
			const res = await client(
				`/v1/carAssetOwners/filter?Page=${$initPage}&Size=50`,
				{
					method: "GET",
					version: "Vehicle",
				}
			);
			data = res?.data?.dataList;
			totalPages.set(res?.data?.totalPage);
			loading.set(false);
		} catch (err) {
			loading.set(false);
			console.log(err);
			extractErrorMessage(err);
		}
	});

	const refreshData = async (type) => {
		try {
			if (type == "delete") {
				loading.set(true);
			} else {
				loadingStatus.set(true);
			}
			const res = await client(
				`/v1/carAssetOwners/filter?Page=${$initPage}&Size=50`,
				{
					method: "GET",
					version: "Vehicle",
				}
			);
			data = res?.data?.dataList;
			totalPages.set(res?.data?.totalPage);
			if (type == "delete") {
				loading.set(false);
			} else {
				loadingStatus.set(false);
			}
		} catch (err) {
			if (type == "delete") {
				loading.set(false);
			} else {
				loadingStatus.set(false);
			}
			extractErrorMessage(err);
			console.log(err);
		}
	};

	let data = [];
	let carAssetOwnerError;
	const carAssetOwner = field("carAssetOwner", "", [required()]);
	const myForm = form(carAssetOwner);

	let load = false;
	const handleSubmit = async () => {
		try {
			load = true;
			loading.set(true);
			const res = await client("/v1/carAssetOwners", {
				method: "POST",
				version: "Vehicle",
				data: {
					name: $carAssetOwner.value,
				},
			});

			if (res?.status === 200) {
				refreshData();
				loading.set(false);
			} else {
				loading.set(false);
				carAssetOwnerError = res?.data?.message;
			}

			load = false;
			loading.set(false);
		} catch (error) {
			console.log(error);
			load = false;
			carAssetOwnerError = error.response.data.message;
			loading.set(false);
		}
	};

	let idStatus;
	async function handleStatusChange(id, status) {
		idStatus = id;
		try {
			loadingStatus.set(true);
			const res = await client("/v1/carAssetOwners/status", {
				method: "PUT",
				version: "Vehicle",
				data: {
					id,
					status,
				},
			});
			if (res?.status === 200) {
				refreshData();
			}
		} catch (err) {
			extractErrorMessage(err);
			console.log(err);
			loadingStatus.set(false);
		}
	}

	async function handleDelete(id) {
		idStatus = id;
		try {
			loading.set(true);
			const res = await client(`/v1/carAssetOwners/${id}`, {
				method: "DELETE",
				version: "Vehicle",
			});
			if (res?.status === 200) {
				refreshData("delete");
			} else if (res?.status === 400) {
				errorMessage.set(res?.data?.message);
			}

			loading.set(false);
		} catch (err) {
			extractErrorMessage(err);
			console.log(err);
			loading.set(false);
		}
	}

	const handleDownloadCSV = async () => {
		try {
			const res = await client("/v1/carAssetOwners/csvFileExport", {
				method: "POST",
				version: "Vehicle",
				data: {
					password: "string",
				},
				// header: "csv",
			});

			const url = window.URL.createObjectURL(new Blob([res?.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", "asset_owner_Template.csv"); //or any other extension
			document.body.appendChild(link);
			link.click();

			// ;
		} catch (err) {
			console.log(err);
			extractErrorMessage(err);
		}
	};

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});

	onDestroy(() => {
		initPage.set(1);
	});
</script>

<Row>
	<Col xs={6}>
		<Col xs={12}>
			<div>
				<Col className="row d-flex align-items-start mx-0">
					<PageHeader title="Vehicle Asset Owner Data" />
				</Col>
			</div>
		</Col>
		<Col xs={12} class="my-3">
			<div>
				<h5><b>Add Vehicle Asset owner</b></h5>
			</div>
			<div>
				<p>*Mandatory fields</p>
			</div>
		</Col>
		<Col>
			<Row>
				<Col>
					<label for="mobile" class="d-block">
						<span> Asset owner name* </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={6}>
					<CustomInput
						type="text"
						bind:value={$carAssetOwner.value}
						error={$myForm.hasError("carAssetOwner.required") ||
							carAssetOwnerError}
						errorText={$myForm.hasError("carAssetOwner.required")
							? "Asset owner name is required"
							: carAssetOwnerError
								? carAssetOwnerError
								: ""}
					/>
				</Col>
				<Col class="d-flex justify-content-start" xs={6}>
					<div class="mx-4 my-1">
						<Button
							class="themeButton primary px-2"
							block
							disabled={!$myForm.valid || !$carAssetOwner.value}
							on:click={myForm.validate}
							on:click={() => handleSubmit()}
						>
							{#if load}
								<Loader />
							{:else}
								Add
							{/if}
						</Button>
					</div>
				</Col>
			</Row>
		</Col>
	</Col>
	<Col class="d-flex justify-content-end" xs={6}>
		<div class="mx-4 text-center">
			<Row>
				<input
					id="fileInput"
					type="file"
					multiple={false}
					hidden="hidden"
					on:change={(e) =>
						handleCsvImport(
							e,
							"/v1/carAssetOwners/csvFileImport",
							"CarAssetOwner"
						)}
				/>
				<label
					type="button"
					for="fileInput"
					id="customButton"
					class="btn themeButton primary px-4 btn"
					block>Import CSV</label
				>
			</Row>
			<Row>
				<p>
					<a
						href="/assets/csv/asset_owner_Template.csv"
						target="_blank"
						download="asset_owner_template.csv"
						rel="noreferrer"
						class="link link-text"
					>
						Download CSV Template
					</a>
				</p>
			</Row>
		</div>
	</Col>

	<Col class="my-5">
		<ErrorMessageHandler message={err} />
		<VehicleAssetOwnerTable
			{data}
			{handleStatusChange}
			{idStatus}
			{handleDelete}
		/>
	</Col>
</Row>
